<div class="p-6">
  <p class="text-sm text-red-600 mb-2 italic font-semibold">
    * This view uses dummy data for demonstration purposes.
  </p>
  <div nz-row [nzGutter]="16" class="mb-4">
    <div nz-col [nzSpan]="6" *ngFor="let stat of statistics">
      <nz-card class="h-full">
        <nz-statistic
          [nzValue]="stat.value"
          [nzTitle]="stat.title"
          [nzSuffix]="stat.suffix || null"
        ></nz-statistic>
      </nz-card>
    </div>
  </div>

  <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="12">
      <nz-card nzTitle="Total leads worked">
        <div style="overflow-x: auto; max-width: 100%">
          <ngx-charts-line-chart
            scheme="vivid"
            [results]="jobRunsData"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="false"
            [autoScale]="true"
          >
          </ngx-charts-line-chart>
        </div>
      </nz-card>
    </div>

    <div nz-col [nzSpan]="12">
      <nz-card nzTitle="Total converted">
        <div style="overflow-x: auto; max-width: 100%">
          <ngx-charts-bar-vertical
            scheme="cool"
            [results]="hostsData"
            [xAxis]="true"
            [yAxis]="true"
          >
          </ngx-charts-bar-vertical>
        </div>
      </nz-card>
    </div>
  </div>
</div>
